import React, { Fragment, useState } from "react";
import {
  useTable,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  TableRow,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  Box,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Menu,
  TableFooter,
  CircularProgress,
  TableContainer,
  Badge,
  Tooltip,
} from "@mui/material";
import { Filter, DefaultColumnFilter, GlobalFilter } from "./filters";
import {
  AddOutlined,
  ExitToAppOutlined,
  ExpandLess,
  ExpandMore,
  ExploreTwoTone,
  HomeWork,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  MoreHorizOutlined,
  SkipNext,
  SkipPrevious,
} from "@mui/icons-material";
import { color } from "../StyleData/Config";
import Loading from "./Loading";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const TableContainerComp = ({
  columns,
  buttonDisable,
  data,
  buttonNew,
  loading,
  display,
  generate,
  handleGenerate,
  statusList,
  menuStatusHandle,
  changeStatusOption,
  filterValue,
  filterShow,
  clone,
  handleCloneButton,
  handleChange,
  iconBadge,
  qrShow,
  iconWOCount,
  iconInspCount,
  woScheduleTypeChange,
  getQrCode,
  isHide,
  calendarHandle,
  handAndtake,
  handleHandOver,
  handleTakeOver,
  filterTypes,
}) => {
  const [exportBL, setExportBL] = useState(null);
  const [exportQr, setExportQr] = useState(null);
  const [dotBL, setDotBL] = useState(null);
  const [statusBL, setStatusBL] = useState(null);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    visibleColumns,
    canPreviousPage,
    canNextPage,
    pageOptions,
    rows,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    flatRows,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: filterTypes || {},
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
  );

  // console.log(flatRows)

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const handleExport = (event) => {
    if (!exportBL) {
      setExportBL(event.currentTarget);
    } else {
      setExportBL(null);
    }
  };
  const handleExportQr = (event) => {
    if (!exportQr) {
      setExportQr(event.currentTarget);
    } else {
      setExportQr(null);
    }
  };
  const handleDot = (event) => {
    if (!dotBL) {
      setDotBL(event.currentTarget);
    } else {
      setDotBL(null);
    }
  };
  const handleStatus = (event) => {
    if (!statusBL) {
      setStatusBL(event.currentTarget);
    } else {
      setStatusBL(null);
    }
  };
  const handleButton = () => {
    buttonNew();
  };
  const exportToCSV = (data, columns, filename = "export.csv") => {
    try {
      const filteredColumns = columns.filter(
        (col) =>
          col.accessor !== "id" &&
          col.Header !== "Actions" &&
          col.accessor !== "duration",
      );

      const headers = filteredColumns.map((col) => col.Header).join(",");
      const rows = data
        .map((row) =>
          filteredColumns
            .map((col) => {
              const value = row[col.accessor];

              if (value === null || value === undefined) return "";
              if (
                col.accessor === "code" ||
                col.accessor === "pmCode" ||
                col.accessor === "serviceRequestCode" ||
                (typeof value === "number" && value > 1e10)
              ) {
                return `="${value}"`;
              }
              if (typeof value === "string")
                return `"${value.replace(/"/g, '""')}"`;

              if (col.isDate && value)
                return new Date(value).toLocaleDateString();

              return String(value);
            })
            .join(","),
        )
        .join("\n");

      const csvContent = [headers, rows].join("\n");
      downloadFile(csvContent, filename, "text/csv");
    } catch (error) {}
  };

  const exportToXML = (data, filename = "export.xml") => {
    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n<data>\n';

    data.forEach((row) => {
      xml += "<row>\n";
      Object.entries(row).forEach(([key, value]) => {
        xml += `<${key}>${escapeXml(value)}</${key}>\n`;
      });
      xml += "</row>\n";
    });

    xml += "</data>";
    downloadFile(xml, filename, "application/xml");
  };

  const escapeXml = (unsafe) => {
    if (typeof unsafe !== "string") return unsafe;
    return unsafe.replace(/[<>&'"]/g, (c) => {
      switch (c) {
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case "&":
          return "&amp;";
        case "'":
          return "&apos;";
        case '"':
          return "&quot;";
        default:
          return c;
      }
    });
  };

  const exportToPDF = (data, columns, filename = "export.pdf") => {
    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
      });

      const filteredColumns = columns.filter(
        (col) =>
          col.accessor !== "id" &&
          col.Header !== "Actions" &&
          col.accessor !== "duration",
      );

      const headers = ["No", ...filteredColumns.map((col) => col.Header)];

      const tableData = data.map((row, index) => [
        (index + 1).toString(),
        ...filteredColumns.map((col) => {
          const value = row[col.accessor];
          if (value === null || value === undefined) return "";
          if (typeof value === "object") return JSON.stringify(value);
          return String(value);
        }),
      ]);

      autoTable(doc, {
        head: [headers],
        body: tableData,
        margin: { top: 20 },
        styles: {
          fontSize: 9,
          cellPadding: 2,
          font: "helvetica",
        },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: "bold",
        },
        columnStyles: {
          0: {
            cellWidth: 10,
            halign: "center",
          },
        },
      });

      doc.save(filename);
    } catch (error) {}
  };

  const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return (
    <Fragment>
      <Box
        sx={{
          backgroundColor: color.TableContainerSearchBgColor,
          mb: "1.5rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
            gap: "1rem",
            p: 1,
          }}
        >
          <Box
            sx={{
              width: "80%",
              display: "flex",
              gap: "0.5rem",
            }}
          >
            {headerGroups.map((headerGroup, i) => (
              <Fragment key={i}>
                {headerGroup.headers.map((column, index) => (
                  <Fragment key={index}>
                    <Filter
                      column={column}
                      placeholder={{ placeholder: column.render("Header") }}
                    />
                  </Fragment>
                ))}
              </Fragment>
            ))}
          </Box>
          <Box sx={{ width: "20%", justifyContent: "flex-end" }}>
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: color.TableContainerSecBgColor,
            p: 1,
            boxShadow: "3px 3px 6px #00000029",
            borderRadius: "3px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1.5rem",
              width: "55%",
            }}
          >
            <Button
              variant="contained"
              disabled={buttonDisable}
              sx={{
                backgroundColor: color.TableButtonColor,
                fontSize: color.fontSize,
                borderRadius: "2px",
                boxShadow: "0px 5px 10px #00000033",
                display: isHide ? "none" : "visible",
              }}
              onClick={handleButton}
            >
              <AddOutlined sx={{ fontSize: "16px" }} /> New
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: color.TableButtonColor,
                fontSize: color.fontSize,
                borderRadius: "2px",
                boxShadow: "0px 5px 10px #00000033",
                display: handAndtake ? "visible" : "none",
              }}
              onClick={handleHandOver}
            >
              Shift HandOver
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: color.TableButtonColor,
                fontSize: color.fontSize,
                borderRadius: "2px",
                boxShadow: "0px 5px 10px #00000033",
                display: handAndtake ? "visible" : "none",
              }}
              onClick={handleTakeOver}
            >
              Shift TakeOver
            </Button>
            <Box
              sx={{ display: display === "notVisible" ? "none" : "visible" }}
            >
              <Button
                variant="outlined"
                disabled={!changeStatusOption}
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: color.fontSize,
                  borderRadius: "2px",
                  display: changeStatusOption ? "flex" : "none",
                }}
                onClick={(e) => {
                  if (statusList !== undefined && changeStatusOption) {
                    handleStatus(e);
                  }
                }}
              >
                Change Status
              </Button>
              <Menu
                anchorEl={statusBL}
                open={Boolean(statusBL)}
                onClose={handleStatus}
              >
                {statusList !== undefined
                  ? statusList.map((list, i) => (
                      <MenuItem
                        key={i}
                        value={list.value}
                        onClick={() => {
                          setStatusBL(null);
                          menuStatusHandle(list);
                        }}
                      >
                        {list.text}
                      </MenuItem>
                    ))
                  : null}
              </Menu>
            </Box>
            {filterShow ? (
              <Select
                fullWidth
                size="small"
                value={filterValue}
                sx={{ width: "20%" }}
                onChange={(e) => {
                  handleChange(e.target.value);
                }}
              >
                <MenuItem value="showAll">Show All</MenuItem>
                <MenuItem value="enableData">Active</MenuItem>
              </Select>
            ) : null}
            {generate ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: color.TableButtonColor,
                  fontSize: color.fontSize,
                  borderRadius: "2px",
                  boxShadow: "0px 5px 10px #00000033",
                }}
                onClick={handleGenerate}
              >
                Generate
              </Button>
            ) : null}
            {clone ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: color.TableButtonColor,
                  fontSize: color.fontSize,
                  borderRadius: "2px",
                  boxShadow: "0px 5px 10px #00000033",
                }}
                onClick={handleCloneButton}
              >
                Clone
              </Button>
            ) : null}
            <Box
              sx={{
                display: display === "notVisible" ? "none" : "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleExport}
            >
              <ExitToAppOutlined
                sx={{ fontSize: "16px", color: color.TableButtonColor }}
              />
              <Typography
                sx={{
                  fontSize: color.fontSize,
                  ml: "0.2rem",
                  color: color.TableButtonColor,
                  fontWeight: 600,
                }}
              >
                Export
              </Typography>
              {Boolean(exportBL) ? (
                <ExpandLess sx={{ fontSize: "17px" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px" }} />
              )}
              <Menu
                anchorEl={exportBL}
                open={Boolean(exportBL)}
                onClose={handleExport}
              >
                <MenuItem
                  onClick={() => {
                    exportToCSV(data, columns, "export.csv");
                    setExportBL(null);
                  }}
                >
                  CSV
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    exportToXML(data, "data_export.xml");
                    setExportBL(null);
                  }}
                >
                  XML
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    exportToPDF(data, columns, "data_export.pdf");
                    setExportBL(null);
                  }}
                >
                  PDF
                </MenuItem>
              </Menu>
            </Box>
            {iconBadge ? (
              <Box
                sx={{ display: "flex", gap: "0.1rem", alignItems: "center" }}
              >
                <Tooltip title="Work Order">
                  <IconButton
                    onClick={() => {
                      woScheduleTypeChange("WO");
                    }}
                  >
                    <Badge badgeContent={iconWOCount} color="primary">
                      <img
                        src="/imagesIcon/workorder.png"
                        style={{ width: "1.5rem", height: "1.5rem" }}
                      />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Inspection">
                  <IconButton
                    onClick={() => {
                      woScheduleTypeChange("INSP");
                    }}
                  >
                    <Badge badgeContent={iconInspCount} color="primary">
                      <img
                        src="/imagesIcon/inspection.png"
                        style={{ width: "1.5rem", height: "1.5rem" }}
                      />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Calendar View">
                  <IconButton
                    onClick={() => {
                      calendarHandle();
                    }}
                  >
                    <img
                      src="/imagesIcon/calendar.png"
                      style={{ width: "1.5rem", height: "1.5rem" }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : null}
            {qrShow ? (
              <Box
                sx={{
                  display: display === "notVisible" ? "none" : "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={handleExportQr}
              >
                <ExitToAppOutlined
                  sx={{ fontSize: "16px", color: color.TableButtonColor }}
                />
                <Typography
                  sx={{
                    fontSize: color.fontSize,
                    ml: "0.2rem",
                    color: color.TableButtonColor,
                    fontWeight: 600,
                  }}
                >
                  Qr Codes
                </Typography>
                {Boolean(exportQr) ? (
                  <ExpandLess sx={{ fontSize: "17px" }} />
                ) : (
                  <ExpandMore sx={{ fontSize: "17px" }} />
                )}
                <Menu
                  anchorEl={exportQr}
                  open={Boolean(exportQr)}
                  onClose={handleExportQr}
                >
                  <MenuItem onClick={() => getQrCode()}>PDF</MenuItem>
                  <MenuItem onClick={() => getQrCode("qr")}>
                    Download Zip
                  </MenuItem>
                </Menu>
              </Box>
            ) : null}
          </Box>
          {/* <Box>
      <MoreHorizOutlined sx={{color:color.TableButtonColor,fontSize:"1.5rem",mr:"2rem",cursor:"pointer"}} onClick={handleDot}/>
      <Menu   anchorEl={dotBL}
          open={Boolean(dotBL)}
          onClose={handleDot}>
          
          <MenuItem>Option 1</MenuItem>
          <MenuItem>Option 2</MenuItem>
          <MenuItem>Option 3</MenuItem>
        </Menu>
      </Box> */}
        </Box>
      </Box>
      {loading ? (
        <Loading />
      ) : (
        <TableContainer
          sx={{
            backgroundColor: color.TableBgColor,
            boxShadow: "0px 5px 10px #00000033",
            border: "0.5px solid rgb(187 187 187 / 31%)",
            borderRadius: "2px",
          }}
        >
          <Table {...getTableProps()}>
            {/* <Filter  column={"CHeck"} /> */}
            <TableHead>
              {headerGroups.map((headerGroup) => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <TableCell
                      {...column.getHeaderProps()}
                      sx={{
                        backgroundColor: "transparent",
                        padding: "1rem 0.4rem",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        fontWeight: 700,
                      }}
                    >
                      <Box
                        sx={{
                          display:
                            column.render("Header") === "reopenCount"
                              ? "none"
                              : "visible",
                        }}
                      >
                        <div {...column.getSortByToggleProps()}>
                          {column.render("Header")}
                          {generateSortingIndicator(column)}
                        </div>
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>

            <TableBody {...getTableBodyProps()}>
              {page.map((row) => {
                //  setRowCountnumber(page)
                // setRowCountnumber([0,1])

                prepareRow(row);
                return (
                  <TableRow key={row.getRowProps().key}>
                    {row.cells.map((cell) => {
                      return (
                        <TableCell
                          {...cell.getCellProps()}
                          sx={{
                            whiteSpace: "nowrap",
                            fontSize: "12px",
                            fontWeight: 600,
                            color: "#797979",
                            border: "none",
                            borderBottom: "1px solid rgba(224, 224, 224, 1)",
                            padding: "0.4rem",
                          }}
                        >
                          {cell.render("Cell")}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {/* <Box
            sx={{
              backgroundColor: color.TableBgColor,
              // boxShadow:"0px 5px 10px #00000033",
              // border:"0.5px solid rgb(187 187 187 / 31%)",
              // borderRadius:"2px"
            }}
          > */}
          {/* <Box sx={{display:"flex",gap:{xs:"5px",md:"2rem"},justifyContent:"flex-end",alignItems:"center",p:"0.4rem",whiteSpace:"nowrap"}}> */}
          {/* <Box
              sx={{
                display: "flex",
                gap: { xs: "5px", md: "2rem" },
                justifyContent: "flex-end",
                alignItems: "center",
                p: "0.4rem",
                whiteSpace: "nowrap",
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <Typography sx={{ display: { xs: "none", md: "block" } }}>
                  Rows:
                </Typography>
                <Select
                  variant="standard"
                  value={pageSize}
                  onChange={onChangeInSelect}
                >
                  {[10, 20, 30, 40, 50].map((pageSize) => (
                    <MenuItem key={pageSize} value={pageSize}>
                      {pageSize}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box>
                <Typography>
                  {pageIndex + 1 + " of " + pageOptions.length}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <IconButton
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                >
                  <SkipPrevious
                    sx={{
                      color: !canPreviousPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton onClick={previousPage} disabled={!canPreviousPage}>
                  <KeyboardArrowLeft
                    sx={{
                      color: !canPreviousPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>

                <IconButton onClick={nextPage} disabled={!canNextPage}>
                  <KeyboardArrowRight
                    sx={{
                      color: !canNextPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                >
                  <SkipNext
                    sx={{
                      color: !canNextPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box> */}
          {/* ✅ Pagination Footer */}
          <Box
            sx={{
              backgroundColor: color.TableBgColor,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: { xs: "5px", md: "2rem" },
                justifyContent: "flex-end",
                alignItems: "center",
                p: "0.4rem",
                whiteSpace: "nowrap",
              }}
            >
              {/* Rows per page */}
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <Typography sx={{ display: { xs: "none", md: "block" } }}>
                  Rows:
                </Typography>
                <Select
                  variant="standard"
                  value={pageSize}
                  onChange={onChangeInSelect}
                >
                  {[10, 20, 30, 40, 50].map((pageSize) => (
                    <MenuItem key={pageSize} value={pageSize}>
                      {pageSize}
                    </MenuItem>
                  ))}
                </Select>
              </Box>

              {/* ✅ Dynamic cumulative record count */}
              <Box>
                <Typography>
                  {Math.min((pageIndex + 1) * pageSize, rows.length) +
                    " of " +
                    rows.length}
                </Typography>
              </Box>

              {/* Navigation buttons */}
              <Box sx={{ display: "flex" }}>
                <IconButton
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                >
                  <SkipPrevious
                    sx={{
                      color: !canPreviousPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton onClick={previousPage} disabled={!canPreviousPage}>
                  <KeyboardArrowLeft
                    sx={{
                      color: !canPreviousPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton onClick={nextPage} disabled={!canNextPage}>
                  <KeyboardArrowRight
                    sx={{
                      color: !canNextPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                >
                  <SkipNext
                    sx={{
                      color: !canNextPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </TableContainer>
      )}

      {/* <Row style={{ maxWidth: 1000, margin: '0 auto', textAlign: 'center' }}>
        <Col md={3}>
          <Button
            color='primary'
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            {'<<'}
          </Button>
          <Button
            color='primary'
            onClick={previousPage}
            disabled={!canPreviousPage}
          >
            {'<'}
          </Button>
        </Col>
        <Col md={2} style={{ marginTop: 7 }}>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </Col>
        <Col md={2}>
          <Input
            type='number'
            min={1}
            style={{ width: 70 }}
            max={pageOptions.length}
            defaultValue={pageIndex + 1}
            onChange={onChangeInInput}
          />
        </Col>
        <Col md={2}>
          <CustomInput
            type='select'
            value={pageSize}
            onChange={onChangeInSelect}
          >
            
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </CustomInput>
        </Col>
        <Col md={3}>
          <Button color='primary' onClick={nextPage} disabled={!canNextPage}>
            {'>'}
          </Button>
          <Button
            color='primary'
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {'>>'}
          </Button>
        </Col>
      </Row> */}
    </Fragment>
  );
};

export default TableContainerComp;
